module.exports = __webpack_public_path__ + "static/media/plan_topic_view.440bfd4e.png";